export enum Subscription {
  PAYPAL = 'paypal',
  STRIPE = 'stripe',
  CANCELED = 'canceled',
  STATUS_MESSAGE = 'Waiting for Final Approval',
  APPROVE = 'approve',
  PAYMENT_COUNTDOWN = 60,
}

export enum UserStatus {
  STARTED = 'started',
  STARTED_PAYMENT = 'startedPayment',
  ACTIVE = 'active',
  LOCKED_INVALID_KEY = 'lockedInvalidKey',
  LOCKED_INVALID_TFA = 'lockedInvalidTFA',
  LOCKED_NO_PAYMENT = 'lockedNoPayment',
  DEATH_NOTIFIED = 'deathNotified',
  DEATH_UNCONFIRMED = 'deathUnconfirmed',
  DEATH_CONFIRMED = 'deathConfirmed',
  TRANSITIONED = 'transitioned',
  CANCELED = 'canceled',
  TERMINATED = 'terminated',
  SUSPENDED_ADMIN = 'suspendedAdmin',
}

export enum Contact {
  TYPE_DESIGNEE = 'designee',
  TYPE_NONE = 'none',
  STATUS_ACTIVE = 'active',
  STATUS_INACTIVE = '',
  ACTOR_SPOUSE = 'spouse',
  ACTOR_EXECUTOR = 'executor',
  ACTOR_PRIMARY_TRUSTEE = 'primarytrustee',
  ACTOR_SECONDARY_TRUSTEE = 'secondarytrustee',
  RELATION_SPOUSE = 'spouse',
  ACTOR_PRIMARY_BENEFICIARY = 'primaryBeneficiary',
  ACTOR_SECONDARY_BENEFICIARY = 'secondaryBeneficiary',
  ACTOR_INSURANCE_BENEFICIARY = 'insuranceBeneficiary',
}

export enum FileActions {
  UPLOAD = 'upload',
  DOWNLOAD = 'download',
}

export enum Analytics {
  GOOGLE_ANALYTICS_LOCATION = 'https://www.googletagmanager.com/gtag/js?id=',
  FACEBOOK_ANALYTICS_LOCATION = 'https://connect.facebook.net/en_US/fbevents.js',
  HOTJAR_ANALYTICS_LOCATION_PREFIX = 'https://static.hotjar.com/c/hotjar-',
  HOTJAR_ANALYTICS_LOCATION_SUFFIX = '.js?sv=',
}

export enum TFAStatus {
  APPROVED = 'approved',
}

export enum UserType {
  ADMIN = 'admin',
  USER = 'user',
  CONTACT = 'contact',
}

export enum SubscriptionPlanNames {
  MON_V01_00 = 'MonV01_00',
  MON_V04_00 = 'MonV04_00',
  ANN_V01_00 = 'AnnV01_00',
  ANN_V04_00 = 'AnnV04_00',
  MON_V01_01 = 'MonV01_01',
  MON_V04_01 = 'MonV04_01',
  ANN_V01_01 = 'AnnV01_01',
  ANN_V04_01 = 'AnnV04_01',
  FREE_V04_00 = 'FreeV04_00',
}

export enum MessageTitle {
  SUCCESS = 'Success',
  ERROR = 'Error',
}

export enum FileStatus {
  PROGRESS = 'progress',
  COMPLETE = 'complete',
  ERROR = 'error',
  CANCELED = 'canceled',
}

export enum RegExPattern {
  ZIP_CODE = '^[0-9]{5}$',
}

export enum ChangeRequestType {
  EMAIL = 'email',
  PHONE = 'phone',
}

export enum AccountSelectionType {
  BANK_ASSETS = 'bankAssets',
  BANK_LIABILITIES = 'bankLiabilities',
  REAL_ESTATE_LOAN = 'realEstateLoan',
}

export enum FinancialAssetType {
  ASSET = 'A',
  LIABILITY = 'L',
}

export enum FileDecryptStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PROCESSING = 'processing',
}

export enum AdminPermission {
  MENU_USERS_ALL = 'menu_users_all',
  MENU_USERS_BLOCKED = 'menu_users_blocked',
  ACTION_TERMS_UPDATE = 'action_terms_update',
  MENU_ADMINS_ALL = 'menu_admins_all',
  ACTION_USER_SUSPEND = 'action_user_suspend',
  ACTION_BLOCKEDUSER_ACTIVATE = 'action_blockeduser_activate',
  ACTION_USER_UPDATE_INFO = 'action_user_updateinfo',
  ACTION_USER_UPDATE_ID_VA = 'action_user_updateIDVA',
  ACTION_USER_UPDATE_SUBSCRIPTION = 'action_user_updateSubscription',
  MENU_USERS_TRANSITIONED = 'menu_users_transitioned',
  MENU_USERS_DEATH_REPORTED = 'menu_users_death_reported',
  MENU_USERS_EXPIRED_SUBSCRIPTION = 'menu_users_expired_subscription',
  ACTION_UPDATE_CONTACTUS = 'action_update_contactus',
  MENU_CONTACTUS_ALL = 'menu_contactus_all',
}

export enum CardName {
  ADDITIONAL_ITEM = 'Additional Items',
  BANKING_INSTITUTION = 'Banking Institution',
  INSURANCE = 'Insurance',
  LOGIN_ACCOUNTS_OR_DEVICES = 'Login accounts or devices',
  PRIVATE_INVESTMENT = 'Private Investments',
  MULTIMEDIA = 'Videos',
  REAL_ESTATE = 'Real Estate',
  RETIREMENT_ACCOUNT = 'Retirement Accounts',
  TRUST = 'Trust',
  WILL = 'Will',
  TAX_RETURN = 'Tax Return',
  TAX_DOCUMENT = 'Tax Document',
  TAX_BASIS_FILES = 'Tax Basis Files',
  IDENTIFICATION = 'Identification',
}

export enum ReportDeathWaitPeriodDays {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  TEN = 10,
  FOURTEEN = 14,
}

export enum ExpiredSubscriptionDays {
  ONE = 1,
  TWO = 2,
  FIVE = 5,
  TEN = 10,
  FIFTEEN = 15,
  THIRTY = 30,
  FORTY_FIVE = 45,
  SIXTY = 60,
  NINETY = 90,
}

export enum ContactUsStatus {
  UNSTARTED = 'UnStarted',
  INPROGRESS = 'InProgress',
  WAITINGFORFEEDBACK = 'WaitingForFeedback',
  CLOSED = 'Closed',
}

export enum TaxReturnType {
  FEDERAL = 'Federal',
  STATE = 'State',
  LOCAL = 'Local',
}

export enum TaxDocumentType {
  INCOME = 'Income',
  DEDUCTIONS = 'Deductions',
  CREDITS = 'Credits',
  ESTIMATED_PAYMENT = 'Estimated Payment',
}

export enum TaxBasisFileType {
  PURCHASE = 'Purchase Information',
  RECEIPT = 'Receipt',
  TAX_CALCULATION = 'Tax Basis by Asset Calculation',
}

export enum IdentificationType {
  DRIVING_LICENSE = 'Driving License',
  PASSPORT = 'Passport',
  SOCIAL_SECURITY_CARD = 'Social Security Card',
  OTHER = 'Other',
}
